/* eslint-disable prettier/prettier */
import OptionsService from "../services/OptionsService";
import router from "../router";

const getDefaultState = () => ({
  options: {
    id: "",
    key: "",
    values: [],
    created_at: "",
    updated_at: "",
  },
  optionsList: [],
  optionsString: [],
  countries: [],
});

const optionsList = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    id(state, val) {
      state.options.id = val;
    },
    key(state, val) {
      state.options.key = val;
    },
    values(state, val) {
      state.options.values = val;
    },
    created_at(state, val) {
      state.options.created_at = val;
    },
    updated_at(state, val) {
      state.options.updated_at = val;
    },
    optionsList(state, val) {
      state.optionsList = val;
    },
    countries(state, val) {
      state.countries = val;
    },
    resetOptionsList(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async GET_OPTIONS(context) {
      let data;
      const res = await OptionsService.fetchOptionsList();
      data = res.data.results;

      context.commit("optionsList", data);

      data.forEach((element) => {
        if (element.key == "countries") {
          context.commit("countries", element.values);
        }
      });
    },
    async UPDATE_OPTIONS(state) {
      const data = {
        ...state.options,
      };
      const res = await OptionsService.updateOptionsList(data);
    },
    async RESET_OPTIONS_STATE(context) {
      await context.commit("resetOptionsList");
    },
  },
  getters: {},
};

export default optionsList;
